import React from 'react';
import { View, Text } from '@adobe/react-spectrum';
import styles from './FilterChip.module.scss';

interface FilterChipProps {
  label: string;
  onRemove: () => void;
  variant?:
    | 'audience'
    | 'productGroup'
    | 'category'
    | 'product'
    | 'event'
    | 'feature'
    | 'lanesTiers'
    | 'genAi'
    | 'revenueImpact'
    | 'status'
    | 'momentType';
}

const CloseIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9 3L3 9M3 3L9 9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export function FilterChip({
  label,
  onRemove,
  variant = 'audience'
}: FilterChipProps) {
  return (
    <View UNSAFE_className={`${styles.chip} ${styles[variant]}`}>
      <Text UNSAFE_className={styles.chipLabel}>{label}</Text>
      <button
        className={styles.closeButton}
        onClick={onRemove}
        aria-label={`Remove ${label} filter`}
        type="button"
      >
        <CloseIcon />
      </button>
    </View>
  );
}

export type { FilterChipProps };
